function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { computed, defineComponent, h } from '@vue/composition-api';
import { withInstall } from '../util';
import { createNamespace } from '../util/create';
import "../style/components/skeleton.css";

var _createNamespace = createNamespace('skeleton'),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

export var SkeletonProps = {
  avatar: {
    type: Boolean,
    "default": true
  },
  loading: {
    type: Boolean,
    "default": true
  },
  avatarSize: {
    type: [Number, String],
    required: false
  },
  row: {
    type: Number,
    "default": 2
  },
  rowWidth: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  animate: {
    type: Boolean,
    "default": true
  },
  className: {
    type: Boolean,
    "default": true
  },
  customStyle: {
    type: Object,
    required: false
  },
  column: {
    type: Number,
    "default": 3
  },
  columnHeight: {
    type: [Number, String],
    required: false
  }
};
var Skeleton = defineComponent({
  name: name,
  model: {
    prop: 'visible',
    event: 'visibleChange'
  },
  props: SkeletonProps,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;
    var avatarStyle = computed(function () {
      return props.avatarSize ? {
        width: props.avatarSize,
        height: props.avatarSize
      } : {};
    });

    var renderDom = function renderDom() {
      if (!props.loading) {
        var _slots$default;

        return (_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots);
      }

      return h("div", {
        "class": "m-skeleton__top"
      }, [props.avatar && h("div", {
        "class": "m-skeleton__top_avatar"
      }, [h("div", {
        "class": "avatar m-ske",
        "style": avatarStyle.value
      })]), h("div", {
        "class": "m-skeleton__top_rows"
      }, [Array(props.row).fill(0).map(function (_, idx) {
        var width = props.rowWidth[idx];
        var style = width ? {
          width: width
        } : {};
        return h("div", {
          "class": "m-skeleton__top_row m-ske",
          "style": style
        });
      })])]);
    };

    var renderColums = function renderColums() {
      if (!props.loading) return;
      h("div", {
        "class": "m-skeleton__columns"
      }, [Array(props.column).fill(0).map(function (_, idx) {
        var style = props.columnHeight ? {
          height: props.columnHeight
        } : {};
        return h("div", {
          "class": "m-skeleton__column m-ske",
          "style": style
        });
      })]);
    };

    return function () {
      var customStyle = props.customStyle || {};
      return h("div", {
        "class": ['m-skeleton', props.className, props.animate ? 'animate' : ''].join(' '),
        "style": customStyle
      }, [renderDom(), renderColums()]);
    };
  }
});
withInstall(Skeleton);
export default Skeleton;